export * from '@aurora/components/template-dialog/template-dialog.component';
